/* globals I18n */

'use strict';

const bindTargetNavigation = require('../../deal/responsive/frontend/bind_target_navigation');
const FetchHandler = require('../../deal/frontend/FetchHandler');

const Getaways = window.Getaways || {};
if (Getaways.TripAdvisor == null) {
  Getaways.TripAdvisor = {
    Templates: {
      getaways_trip_advisor_review: require('../trip_advisor_review.html.mustache'),
      getaways_touch_trip_advisor_review: require('../responsive/trip_advisor_review.html.mustache'),
    },
  };
}

// Averaged body length (used to include read more trigger)
const BODY_DISPLAY_LIMIT_DESKTOP = 290;

// Averaged body length (used to include the expanded class)
const BODY_DISPLAY_LIMIT_TOUCH = 150;

// Sticky Header Height (used to add an offset on DealV2)
const STICKY_HEADER_HEIGHT = 65;

Getaways.TripAdvisor.init = function(options = {}, done) {
  const target = document.querySelector('#trip-advisor-body');

  if (target == null) {
    done();
    return '';
  }

  let reviewsLoaded, template;

  const { dealUUID, touch, tripAdvisor } = options;
  const stickyHighlight = document.querySelector('.deal-highlights.sticky-ums');

  const toMonthName = Object.values(
    I18n.t('js.modules.getaways.booking_calendar.touch.month_names')
  );

  const dateStringToDate = function(dateString) {
    const errMsg = 'Date string YYYY-MM-DD is required';
    if (typeof dateString !== 'string') {
      throw TypeError(errMsg);
    }
    const dateParts = dateString.split('-');
    if (dateParts.length !== 3) {
      throw TypeError(errMsg);
    }
    return new Date(+dateParts[0], +dateParts[1] - 1, +dateParts[2]);
  };

  const prettifyDate = function(dateString) {
    if (isNaN(Date.parse(dateString))) {
      return null;
    }

    const date = dateStringToDate(dateString);
    return I18n.t('js.modules.getaways.trip_advisor.review_date_format', {
      month_name: toMonthName[date.getMonth()],
      day: date.getDate(),
      year: date.getFullYear(),
    });
  };

  const prettifyReviewDate = review => prettifyDate(review.publishedDate);

  const bindTATouchExpand = function(elem) {
    if (!elem.classList.contains('expanded')) {
      elem.addEventListener('click', () => elem.classList.toggle('expanded'));
    }
  };

  const bindTAShowLink = function(elem) {
    const showMoreLink = elem.querySelector('.ta-show-more');

    if (!showMoreLink) {
      return;
    }

    const description = elem.querySelector('.ta-review-description');
    const textContainer = elem.querySelector('.ta-review-text');

    showMoreLink.addEventListener('click', () => {
      if (description) {
        description.classList.toggle('expanded');
      }

      if (textContainer) {
        textContainer.innerHTML = textContainer.dataset.text;
      }
    });
  };

  // Review Level Events
  const bindTAExpandClicks = function(elem) {
    const items = elem.querySelectorAll('.ta-review');

    items.forEach(item =>
      touch ? bindTATouchExpand(item) : bindTAShowLink(item)
    );
  };

  const calculateRatingSpriteNumber = review => parseFloat(review.rating) * 2;

  const isShowMoreNeeded = function(review, readMoreLimit) {
    return review.body ? review.body.length > readMoreLimit : false;
  };

  const truncateReviewText = function(review, readMoreLimit) {
    return `${review.body.slice(0, readMoreLimit)}...`;
  };

  const handleLongReviewText = function(review) {
    const bodyDisplayLimit = touch
      ? BODY_DISPLAY_LIMIT_TOUCH
      : BODY_DISPLAY_LIMIT_DESKTOP;
    review.showReadMore = isShowMoreNeeded(review, bodyDisplayLimit);

    if (review.showReadMore && !touch) {
      return (review.truncatedBody = truncateReviewText(
        review,
        bodyDisplayLimit
      ));
    }

    return null;
  };

  const formatForDisplay = function(review, reviewIndex) {
    handleLongReviewText(review);

    return Object.assign(review, {
      ratingSpriteNumber: calculateRatingSpriteNumber(review),
      prettyPublishedDate: prettifyReviewDate(review),
      index: reviewIndex,
    });
  };

  // formatting helpers
  const formatReviews = reviews =>
    Array.from(reviews).map((review, i) => formatForDisplay(review, i));

  const loadTripAdvisorReviewDetails = function(promise) {
    const url = tripAdvisor ? tripAdvisor.reviewsUrl : undefined;

    if (
      !tripAdvisor ||
      !tripAdvisor.shouldShowTripAdvisorReviewsDetails ||
      !url
    ) {
      target.innerHTML = '';
      return;
    }

    const handler = new FetchHandler({
      url,
      successHandlers: data => {
        if (!data || !data.reviews || !data.reviews.length) {
          const message = I18n.translate(
            'js.modules.getaways.trip_advisor.no_reviews_for_lang'
          );

          target.innerHTML = `<p class='error-text'>${message}</p>`;
          return;
        }

        const formattedReviews = formatReviews(data.reviews);

        const hash = {
          translate() {
            return key => I18n.t(key);
          },
          tripAdvisor: {
            reviews: formattedReviews,
          },
        };

        target.innerHTML = template.render(hash);
        reviewsLoaded = true;

        bindTAExpandClicks(target);
      },

      errorHandlers: () => {
        const message = I18n.translate(
          'js.modules.getaways.trip_advisor.error_text'
        );
        target.innerHTML = `<p class='error-text'>${message}</p>`;
      },

      completeHandlers: () => {
        if (promise) {
          promise.resolve();
        }
      },
    });

    handler.send();
  };

  Getaways.TripAdvisor.loadTripAdvisorReviewDetails = loadTripAdvisorReviewDetails;

  const scrollToTarget = function(targetElem) {
    const scrollPane = document.querySelector('body');
    const stickyOffset = stickyHighlight ? STICKY_HEADER_HEIGHT : 0;

    const rect = targetElem.getBoundingClientRect();
    const { browser } = window.TrackingHub ? window.TrackingHub.user : {};

    const scrollLength = rect.top + scrollPane.scrollTop - stickyOffset;

    if (browser && /Chrome|Firefox/i.test(browser)) {
      window.scrollTo({
        top: scrollLength,
        behavior: 'smooth',
      });
    } else {
      window.scrollTo(0, scrollLength);
    }
  };

  const showTripAdvisorDrawer = function(promise) {
    const tripAdvisorDrawer = document.querySelector(
      '.toggle-drawer.trip-advisor-block'
    );

    if (tripAdvisorDrawer) {
      const drawerContent = tripAdvisorDrawer.querySelector('.toggle-content');

      if (drawerContent) {
        if (reviewsLoaded) {
          promise.resolve();
        } else {
          tripAdvisorDrawer.classList.add('open');
        }
      }
    }
  };

  Getaways.TripAdvisor.showTripAdvisorDrawer = showTripAdvisorDrawer;

  // Module Level Events
  const initTripAdvisorTouch = function() {
    const tripAdvisorHeader = document.querySelector('#trip-advisor-header');

    if (tripAdvisorHeader) {
      tripAdvisorHeader.addEventListener('click', () => {
        if (!reviewsLoaded) {
          loadTripAdvisorReviewDetails(dealUUID);
        }
      });
    }

    const tripAdvisorHighlight = document.querySelector(
      'a.trip-advisor-rating'
    );

    bindTargetNavigation(tripAdvisorHighlight, promise => {
      if (!reviewsLoaded) {
        loadTripAdvisorReviewDetails(promise);
      }

      showTripAdvisorDrawer(promise);
    });
  };

  const initTADesktopHeaderLink = function() {
    const headerLinkContainer = document.querySelector('#trip-advisor-summary');
    const $reviewsContainer = document.querySelector('#trip-advisor-reviews');

    if (headerLinkContainer) {
      headerLinkContainer.addEventListener('click', () => {
        const offset = 0;

        scrollToTarget($reviewsContainer, offset);
      });
    }
  };

  const hasTAReviews = tripAdvisor ? tripAdvisor.hasTAReviews : false;

  if (touch) {
    template =
      Getaways.TripAdvisor.Templates.getaways_touch_trip_advisor_review;
    if (hasTAReviews) {
      initTripAdvisorTouch();
    }
  } else {
    template = Getaways.TripAdvisor.Templates.getaways_trip_advisor_review;
    if (hasTAReviews) {
      initTADesktopHeaderLink();
      loadTripAdvisorReviewDetails();
    }
  }

  done();

  return '';
};

module.exports = Getaways.TripAdvisor;
